"use strict";
exports.__esModule = true;
exports.chart_axis_axis_stroke_Color = {
  "name": "--pf-chart-axis--axis--stroke--Color",
  "value": "#d2d2d2",
  "var": "var(--pf-chart-axis--axis--stroke--Color, #d2d2d2)"
};
exports["default"] = exports.chart_axis_axis_stroke_Color;